import React from 'react' 
import { TransitionAnimation, TransitionAnimationProps } from '../TransitionAnimation'
 

export const Transition = ({children, ...props}) => (
    <TransitionAnimation {...props} animationStyle="transition">
        {children}
    </TransitionAnimation>
)

Transition.propTypes = TransitionAnimationProps 